import QuoteExtras from './QuoteExtras';
export default QuoteExtras;
